export default "__VITE_ASSET__CKFrn2Kj__"